import { motion } from "framer-motion";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { WA_DEFAULT_LINK } from "../constants/site";

export const WhatsAppFloat = () => (
    <motion.a
        href={WA_DEFAULT_LINK}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ y: 90, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
        data-testid="whatsapp-fixed-bar"
        className="fixed bottom-3 inset-x-3 z-50 lg:hidden inline-flex items-center justify-center gap-3 rounded-full bg-wa text-white font-display font-bold uppercase tracking-wide text-sm px-6 py-4 shadow-[0_16px_35px_-8px_rgba(34,165,89,0.65)]"
        style={{ paddingBottom: "max(1rem, env(safe-area-inset-bottom))" }}
    >
        <WhatsAppIcon className="w-5 h-5 shrink-0" />
        Atendimento pelo WhatsApp
    </motion.a>
);
